(function () {
  function pauseOthers(current) {
    document.querySelectorAll('.lp-fitness-videos__video').forEach(function (video) {
      if (video !== current) {
        video.pause();
        var media = video.closest('[data-lp-video]');
        if (media) media.classList.remove('is-playing');
        video.removeAttribute('controls');
      }
    });
  }

  function play(media) {
    var video = media.querySelector('video');
    if (!video) return;
    pauseOthers(video);
    video.setAttribute('controls', 'controls');
    media.classList.add('is-playing');
    var result = video.play();
    if (result && typeof result.catch === 'function') {
      result.catch(function () {
        media.classList.remove('is-playing');
        video.removeAttribute('controls');
      });
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-lp-video-play]');
    if (!trigger) return;
    var media = trigger.closest('[data-lp-video]');
    if (media) play(media);
  });

  // Restore the poster/overlay when a video finishes or is paused by the user.
  document.addEventListener(
    'ended',
    function (event) {
      var video = event.target;
      if (video.classList && video.classList.contains('lp-fitness-videos__video')) {
        var media = video.closest('[data-lp-video]');
        if (media) media.classList.remove('is-playing');
        video.removeAttribute('controls');
      }
    },
    true
  );
})();
